import { Injectable } from "@angular/core";
import { IGlobalParameter, IPreference, PreferenceContext } from "@comunicare/comunicare-interfaces";
import { IPreferenceService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";
import { PreferenceApiService } from "./api/preference-api.service";
import { SessionService } from "./session.service";

@Injectable({
  providedIn: "root",
})
export class PreferenceService implements IPreferenceService {
  private listCache: Record<string, any> = [];

  constructor(private preferenceApi: PreferenceApiService, private sessionService: SessionService) {}

  public list(context: string): Observable<null | any> {
    if (this.listCache[context] !== undefined) {
      return of(this.listCache[context]);
    }

    return this.preferenceApi.list(context).pipe(
      map((parameters) => {
        if (!parameters) {
          return null;
        }
        return parameters;
      }),
      tap((parameters) => {
        this.listCache[context] = parameters;
      })
    );
  }

  public update(preference: IPreference) {
    this.listCache[preference.context] = undefined;

    if (preference.context === PreferenceContext.GLOBAL) {
      this.sessionService.globalPref = preference.parameters;
    }
    return this.preferenceApi.update(preference);
  }

  public clear(): void {
    this.listCache = [];
  }

  public getGlobal(): Observable<null | IGlobalParameter> {
    const globalParameter = this.sessionService.globalPref;
    if (!globalParameter) {
      return this.preferenceApi.list(PreferenceContext.GLOBAL).pipe(
        tap((parameters: IGlobalParameter) => {
          this.sessionService.globalPref = parameters;
        })
      );
    } else {
      return this.sessionService.getObservablePref();
    }
  }

  public getAutoRefreshWidget() {
    return 60000;
  }

  public getAutoSaveInterval() {
    return 10000;
  }
}
